var _rect, _line, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.19531,
    y: 0.608887,
    width: 25.8042,
    height: 16.7823,
    rx: 2.5,
    stroke: "#888B94"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.25,
    y1: 6.75,
    x2: 27.5,
    y2: 6.75,
    stroke: "#888B94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 13.25,
    width: 4.25,
    height: 1,
    rx: 0.5,
    fill: "#888B94"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.84766,
    y: 13.25,
    width: 4.25,
    height: 1,
    rx: 0.5,
    fill: "#888B94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitcard);
export default __webpack_public_path__ + "static/media/debitcard.08ef81becdea0d20ed3950b95515c414.svg";
export { ForwardRef as ReactComponent };